"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var titForTat_1 = require("./titForTat");
var testEach_1 = require("./testEach");
exports.transliterate = function (text) {
    var normalize = text.normalize("NFKD");
    var titTat = titForTat_1.titForTat(normalize);
    var array = titTat.split(" ");
    var modArray = testEach_1.testEach(array);
    var transliteration = modArray.join(" ");
    return transliteration;
};
